import { Invoice } from "types";
import { cloudFunction } from "../helpers/cloudfunction";

type ResumeIssueInvoiceParams = {
  invoiceId: string;
  marketId: string;
};

export async function resumeIssueInvoice(params: ResumeIssueInvoiceParams) {
  let func = cloudFunction<ResumeIssueInvoiceParams, Invoice>(
    "resumeIssueInvoice"
  );

  if (!params.marketId) {
    throw new Error(`MarketID needs to be specified`);
  }

  if (!params.invoiceId) {
    throw new Error(`InvoiceID needs to be specified`);
  }

  let result = await func(params);
  console.log("resume invoice result", result);

  return result;
}
